import {
    Activity,
    Building2,
    Gauge,
    LayoutDashboard,
    RefreshCw,
    Scale,
    type LucideIcon,
} from 'lucide-react';
import type { DashboardTabId, GetDashboardTabIconParams } from '../types';

const DASHBOARD_TAB_ICONS: Record<DashboardTabId, LucideIcon> = {
    summary: LayoutDashboard,
    growth: Gauge,
    'unit-economics': Scale,
    retention: RefreshCw,
    engagement: Activity,
    organizations: Building2,
};

const getDashboardTabIcon = ({ tabId }: GetDashboardTabIconParams): LucideIcon =>
    DASHBOARD_TAB_ICONS[tabId];

export default getDashboardTabIcon;
